import React, { useEffect, useRef, useState } from 'react';
import './ScoreGauge.css';
import exp_img from "../assets/imgs/Experian_logo.png";
import { formatTimestampForLastUpdated } from '../utils/GenericInsightStack';
const calculateNeedleAngle = (score) => {
    const minScore = 300;
    const maxScore = 900;
    const minAngle = -124;
    const maxAngle = 124;
    const scorePercentage = (score - minScore) / (maxScore - minScore);
    return minAngle + scorePercentage * (maxAngle - minAngle);
};
const ScoreGauge = ({ score, isLoading, lastUpdated }) => {
    const needleRef = useRef(null);
    const [animatedScore, setAnimatedScore] = useState(300); // Start from 300
    useEffect(() => {
        if (isLoading) return; // Wait until isLoading is false
        let currentScore = 300; // Starting score
        const interval = setInterval(() => {
            if (currentScore < score) {
                currentScore += 10; // Increment by 10
                setAnimatedScore(Math.min(currentScore, score)); // Update animated score
            } else {
                clearInterval(interval); // Stop animation at target score
            }
        }, 5);

        return () => clearInterval(interval); // Cleanup on unmount
    }, [score]);

    useEffect(() => {
        if (needleRef.current) {
            const needleAngle = calculateNeedleAngle(animatedScore);
            needleRef.current.style.transform = `translate(0%, -50%) rotate(${needleAngle}deg)`;
        }
    }, [animatedScore]);
    const checkColour = (Sc) => {
        if (Sc >= 300 && Sc < 700) {
            return `#f51111`;
        } else if (Sc >= 700 && Sc < 800) {
            return `#6dbc5d`;
        } else {
            return `#12a547`;
        }
    };

    const getCreditRemark = (score) => {
        if (score === 0) return "NEW";
        if (score >= 300 && score < 400) return "Need Attention";
        if (score >= 400 && score < 500) return "Poor";
        if (score >= 500 && score < 600) return "Below Average";
        if (score >= 600 && score < 700) return "Average";
        if (score >= 700 && score < 750) return "Good";
        if (score >= 750 && score < 800) return "Great";
        if (score >= 800 && score <= 900) return "Excellent";
        return "-"; // fallback for invalid scores
    }
    return (<>
        <div className='main-score-guage'>
            <div className='main-score-guage-block'>
                <div className='main-score-guage-block-value-support-bar'>
                </div>
                {/* <div className='main-score-guage-block-value-support'>
                </div> */}
                <div className='main-score-guage-block-value-support-1'>
                </div>
                <div
                    ref={needleRef}
                    className="main-score-guage-block-value-support-1 triangle-shape-needle-in-gauge"
                ></div>
                <div className='main-score-guage-block-value-support-2'>

                    <div className='main-score-guage-block-values'>
                        <div className='main-score-guage-block-value-1'>{animatedScore}</div>
                        <div
                            style={{ color: checkColour(score) }}
                            className='main-score-guage-block-value-2'>
                            {/* {score >= 800 ? 'Excellent' :
                                score >= 700 ? 'Good' :
                                    score >= 600 ? 'Fair' : 'Bad'} */}
                            {getCreditRemark(score)}
                        </div>
                    </div>

                </div>
                <div className="new-score-gauge-milstone-1">300</div>
                <div className="new-score-gauge-milstone-2">600</div>
                <div className="new-score-gauge-milstone-3">700</div>
                <div className="new-score-gauge-milstone-4">800</div>
                <div className="new-score-gauge-milstone-5">900</div>
            </div>
            <div className='main-score-guage-bottom'>
                <div className='main-score-guage-bottom-1'>
                    <span className='powered-by-title'>Powered BY</span>
                    <img src={exp_img} alt="exp-img" />
                </div>
                {
                    lastUpdated ?
                        <p className='main-score-guage-bottom-2'>
                            Last Updated on
                            <b>
                                {formatTimestampForLastUpdated(lastUpdated)}
                            </b>
                        </p>
                        :
                        null
                }

            </div>
        </div>
    </>)
}
export default ScoreGauge;
